import { useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import firebase from 'firebase/compat/app';
import AudioRecorder from 'audio-recorder-polyfill'
window.MediaRecorder = AudioRecorder;

const useRecorder = () => {
  const [audioURL, setAudioURL] = useState("");
  const [isRecording, setIsRecording] = useState(false);
  const [recorder, setRecorder] = useState(null);
  const [audio, setAudio] = useState(null);

  useEffect(() => {
    // Lazily obtain recorder first time we're recording.
    if (recorder === null) {
      if (isRecording) {
        requestRecorder().then(setRecorder, console.error);
      }
      return;
    }

    // Manage recorder state.
    if (isRecording) {
      recorder.start();
    } else {
      recorder.stop();
    }

    // Obtain the audio when ready.
    const handleData = e => {
      setAudio(e.data);
      setAudioURL(URL.createObjectURL(e.data));
    };

    recorder.addEventListener("dataavailable", handleData);
    return () => recorder.removeEventListener("dataavailable", handleData);
  }, [recorder, isRecording]);

  const startRecording = () => {
    setIsRecording(true);
  };

  const stopRecording = () => {
    setIsRecording(false);
  };

  const handleAudioUpload = async () => {

    const upload = await firebase.storage().ref(`consultAnswersVoiceNotes/${uuidv4()}/consultAnswerVoiceNote.mp3`).put(audio);

    await upload.ref.getDownloadURL().then(async (res) => {
        setAudioURL(res);
    });

}

  return [audioURL, isRecording, startRecording, stopRecording, handleAudioUpload];
};

async function requestRecorder() {
  const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
  return new window.MediaRecorder(stream);
}
export default useRecorder;